import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { INITIAL_IMG_INDEX, MAX_IMAGES_LENGTH } from './constants';

/** TODO: не используется */
@Component({
  selector: 'lp-view-images-carousel',
  templateUrl: './view-images-carousel.component.html',
  styleUrls: ['./view-images-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewImagesCarouselComponent extends BaseResizableComponent {
  @Input() imageIds: string[] = [];
  @Input() productUnionId?: string | null;

  readonly maxImagesLength = MAX_IMAGES_LENGTH;

  selectedImgIndex = INITIAL_IMG_INDEX;

  downloadedPhotoIndexes: number[] = [INITIAL_IMG_INDEX, INITIAL_IMG_INDEX + 1];

  touchmove() {
    // HACK: для корректной отрисовки плавного перелистывания фото в мобильных приложениях
    this.cdr.markForCheck();
  }

  // HACK: для карусели. При выбранном последнем элементе, справа появляется пустое пространство
  get carouselPreviewIndex() {
    if (this.imageIds.length < MAX_IMAGES_LENGTH) {
      return 0;
    }

    return this.selectedImgIndex < this.imageIds.length - MAX_IMAGES_LENGTH
      ? this.selectedImgIndex
      : this.imageIds.length - MAX_IMAGES_LENGTH;
  }

  navigate(delta: number) {
    const newIndex = this.selectedImgIndex + delta;

    if (newIndex < 0) {
      this.changeImageIndex(this.imageIds.length - 1);
    } else if (newIndex > this.imageIds.length - 1) {
      this.changeImageIndex(0);
    } else {
      this.changeImageIndex(newIndex);
    }
  }

  changeImageIndex(index: number) {
    this.saveDownloadedImgIndex(index);

    if (this.selectedImgIndex !== index) {
      this.selectedImgIndex = index;
    }

    this.cdr.markForCheck();
  }

  saveDownloadedImgIndex(photoIndex: number) {
    [photoIndex, photoIndex + 1].forEach(index => {
      if (!this.downloadedPhotoIndexes.includes(index)) {
        this.downloadedPhotoIndexes.push(index);
      }
    });
  }
}
